import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";

import { appSetRightDrawerOpen } from "../../redux/app/appActions";

import { styled, Drawer, Divider } from '@mui/material';

const PREFIX = 'SettingsDrawer';

const classes = {
    drawer: `${PREFIX}-drawer`,
    drawerPaper: `${PREFIX}-drawerPaper`,
    toolbar: `${PREFIX}-toolbar`,
    drawerHeader: `${PREFIX}-drawerHeader`
};

const StyledDrawer = styled(Drawer)((
    {
        theme
    }
) => ({
    // [`&.${classes.drawer}`]: {
    //     width: drawerWidth,
    //     flexShrink: 0,
    //     overflow: 'hidden'
    // },
	width: drawerWidth,
	flexShrink: 0,
	overflow: 'hidden',

    [`& .${classes.drawerPaper}`]: {
        right: 0,
        width: drawerWidth,
        overflow: 'hidden',
        zIndex: 1
    },

    [`& .${classes.toolbar}`]: theme.mixins.toolbar,

    [`& .${classes.drawerHeader}`]: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
    }
}));

const drawerWidth = 360;

export default function SettingsDrawer() {

    const dispatch = useDispatch();

    // Component State
    const [settingsContent, setSettingsContent] = useState(null);

    // App State
    const rightDrawerOpen = useSelector(state => state.app.rightDrawerOpen);
    const appSettingsContent = useSelector(state => state.app.settingsContent);

    useEffect(() => {
        if (!appSettingsContent)
            dispatch(appSetRightDrawerOpen(false));

        setSettingsContent(appSettingsContent);
    }, [appSettingsContent]);

    return (
        <StyledDrawer
            variant="persistent"
            anchor="right"
            classes={{
                paper: classes.drawerPaper,
            }}
            open={rightDrawerOpen}
        >
            <div className={classes.toolbar} />
            {/*<div className={classes.drawerHeader}>*/}
            {/*    <IconButton onClick={closeRightDrawer}>*/}
            {/*        <ChevronRightIcon />*/}
            {/*    </IconButton>*/}
            {/*</div>*/}
            <Divider />
			<div style={{height: '100%', width: '100%', overflow: 'auto'}}>
            	{settingsContent}
            </div>
        </StyledDrawer>
    );
}
